module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dTB9a"))).then(() => parcelRequire('hEqeo'));